import React from 'react';
import { useGLTF } from '@react-three/drei';

export function World() {
  const { nodes, materials } = useGLTF('/world.glb');
  return (
    <group dispose={null}>
      <group
        name="Dock_Long"
        position={[44.5, -4.23, -56.39]}
        rotation={[-Math.PI / 2, 0, -0.46]}
        scale={50}
      >
        <mesh
          name="Dock_Long_1"
          castShadow
          receiveShadow
          geometry={nodes.Dock_Long_1.geometry}
          material={materials.Wood}
        />
        <mesh
          name="Dock_Long_2"
          castShadow
          receiveShadow
          geometry={nodes.Dock_Long_2.geometry}
          material={materials.LightWood}
        />
        <mesh
          name="Dock_Long_3"
          castShadow
          receiveShadow
          geometry={nodes.Dock_Long_3.geometry}
          material={materials.String}
        />
      </group>
      <group
        name="Lamp"
        position={[7.84, -7.91, 5.8]}
        rotation={[-0.27, 0.6, 1.93]}
      />
      <group
        name="Lamp002"
        position={[7.95, 7.92, 5.8]}
        rotation={[-0.27, 0.6, 1.93]}
      />
      <group
        name="Lamp004"
        position={[-7.9, 7.86, 5.8]}
        rotation={[-0.27, 0.6, 1.93]}
      />
      <group
        name="Lamp006"
        position={[-8.04, -7.91, 5.8]}
        rotation={[-0.27, 0.6, 1.93]}
      />
      <group
        name="Sign12"
        position={[-2.75, -0.37, -13.61]}
        rotation={[0, 0.28, 0]}
        scale={100}
      >
        <mesh
          name="Sign12_1"
          castShadow
          receiveShadow
          geometry={nodes.Sign12_1.geometry}
          material={materials['Light Wood']}
        />
        <mesh
          name="Sign12_2"
          castShadow
          receiveShadow
          geometry={nodes.Sign12_2.geometry}
          material={materials['Dark Wood']}
        />
        <mesh
          name="Sign12_3"
          castShadow
          receiveShadow
          geometry={nodes.Sign12_3.geometry}
          material={materials.Herbs}
        />
        <mesh
          name="Sign12_4"
          castShadow
          receiveShadow
          geometry={nodes.Sign12_4.geometry}
          material={materials.Rocks}
        />
      </group>
      <group
        name="palm_tree_01"
        position={[-58.66, -1.49, -39.64]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh'].geometry}
          material={materials['795548']}
        />
        <mesh
          name="palm_tree_01-Mesh_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh_1'].geometry}
          material={materials['8BC34A']}
        />
        <mesh
          name="palm_tree_01-Mesh_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh_2'].geometry}
          material={materials.DD9944}
        />
      </group>
      <group
        name="palm_tree_01001"
        position={[-83.7, -2.56, -25.15]}
        rotation={[-Math.PI, 0.92, -Math.PI]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh001"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh001'].geometry}
          material={materials['795548.001']}
        />
        <mesh
          name="palm_tree_01-Mesh001_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh001_1'].geometry}
          material={materials['8BC34A.001']}
        />
        <mesh
          name="palm_tree_01-Mesh001_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh001_2'].geometry}
          material={materials['DD9944.001']}
        />
      </group>
      <group
        name="palm_tree_01002"
        position={[-75.02, -2.56, -44.81]}
        rotation={[-2.97, 0.91, 2.93]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh002"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh002'].geometry}
          material={materials['795548.002']}
        />
        <mesh
          name="palm_tree_01-Mesh002_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh002_1'].geometry}
          material={materials['8BC34A.002']}
        />
        <mesh
          name="palm_tree_01-Mesh002_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh002_2'].geometry}
          material={materials['DD9944.002']}
        />
      </group>
      <group
        name="palm_tree_01003"
        position={[-75.02, -2.99, -5.4]}
        rotation={[3.03, 0.92, -3]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh003"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh003'].geometry}
          material={materials['795548.003']}
        />
        <mesh
          name="palm_tree_01-Mesh003_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh003_1'].geometry}
          material={materials['8BC34A.003']}
        />
        <mesh
          name="palm_tree_01-Mesh003_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh003_2'].geometry}
          material={materials['DD9944.003']}
        />
      </group>
      <group
        name="palm_tree_01004"
        position={[-54.19, -1.55, -5.4]}
        rotation={[3.07, 0.41, -3.06]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh004"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh004'].geometry}
          material={materials['795548.004']}
        />
        <mesh
          name="palm_tree_01-Mesh004_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh004_1'].geometry}
          material={materials['8BC34A.004']}
        />
        <mesh
          name="palm_tree_01-Mesh004_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh004_2'].geometry}
          material={materials['DD9944.004']}
        />
      </group>
      <group
        name="palm_tree_01005"
        position={[-54.19, -2.36, 5.79]}
        rotation={[3.07, 0.41, -3.06]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh005"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh005'].geometry}
          material={materials['795548.005']}
        />
        <mesh
          name="palm_tree_01-Mesh005_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh005_1'].geometry}
          material={materials['8BC34A.005']}
        />
        <mesh
          name="palm_tree_01-Mesh005_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh005_2'].geometry}
          material={materials['DD9944.005']}
        />
      </group>
      <group
        name="palm_tree_01006"
        position={[-18.84, -2.21, -66.5]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh006"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh006'].geometry}
          material={materials['795548.006']}
        />
        <mesh
          name="palm_tree_01-Mesh006_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh006_1'].geometry}
          material={materials['8BC34A.006']}
        />
        <mesh
          name="palm_tree_01-Mesh006_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh006_2'].geometry}
          material={materials['DD9944.006']}
        />
      </group>
      <group
        name="palm_tree_01007"
        position={[-39.25, -2.36, -57.47]}
        rotation={[0.64, 0.91, -0.76]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh007"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh007'].geometry}
          material={materials['795548.007']}
        />
        <mesh
          name="palm_tree_01-Mesh007_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh007_1'].geometry}
          material={materials['8BC34A.007']}
        />
        <mesh
          name="palm_tree_01-Mesh007_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh007_2'].geometry}
          material={materials['DD9944.007']}
        />
      </group>
      <group
        name="palm_tree_01008"
        position={[32.79, -2.21, -36.34]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh008"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh008'].geometry}
          material={materials['795548.008']}
        />
        <mesh
          name="palm_tree_01-Mesh008_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh008_1'].geometry}
          material={materials['8BC34A.008']}
        />
        <mesh
          name="palm_tree_01-Mesh008_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh008_2'].geometry}
          material={materials['DD9944.008']}
        />
      </group>
      <group
        name="palm_tree_01009"
        position={[36.38, -1.62, -23.83]}
        rotation={[-Math.PI, 0.3, -2.69]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh009"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh009'].geometry}
          material={materials['795548.009']}
        />
        <mesh
          name="palm_tree_01-Mesh009_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh009_1'].geometry}
          material={materials['8BC34A.009']}
        />
        <mesh
          name="palm_tree_01-Mesh009_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh009_2'].geometry}
          material={materials['DD9944.009']}
        />
      </group>
      <group
        name="palm_tree_01010"
        position={[32.79, -2.21, 31.49]}
        rotation={[-0.04, -0.02, -0.03]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh010"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh010'].geometry}
          material={materials['795548.010']}
        />
        <mesh
          name="palm_tree_01-Mesh010_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh010_1'].geometry}
          material={materials['8BC34A.010']}
        />
        <mesh
          name="palm_tree_01-Mesh010_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh010_2'].geometry}
          material={materials['DD9944.010']}
        />
      </group>
      <group
        name="palm_tree_01011"
        position={[44.79, -2.21, 21.85]}
        rotation={[0, -1.14, 0]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh011"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh011'].geometry}
          material={materials['795548.011']}
        />
        <mesh
          name="palm_tree_01-Mesh011_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh011_1'].geometry}
          material={materials['8BC34A.011']}
        />
        <mesh
          name="palm_tree_01-Mesh011_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh011_2'].geometry}
          material={materials['DD9944.011']}
        />
      </group>
      <group
        name="palm_tree_01012"
        position={[-26.72, -2.21, 48.08]}
        rotation={[0.06, -0.35, 0.04]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh012"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh012'].geometry}
          material={materials['795548.012']}
        />
        <mesh
          name="palm_tree_01-Mesh012_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh012_1'].geometry}
          material={materials['8BC34A.012']}
        />
        <mesh
          name="palm_tree_01-Mesh012_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh012_2'].geometry}
          material={materials['DD9944.012']}
        />
      </group>
      <group
        name="palm_tree_01013"
        position={[-0.27, -2.21, 43.98]}
        rotation={[-0.13, -1.22, -0.1]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh013"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh013'].geometry}
          material={materials['795548.013']}
        />
        <mesh
          name="palm_tree_01-Mesh013_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh013_1'].geometry}
          material={materials['8BC34A.013']}
        />
        <mesh
          name="palm_tree_01-Mesh013_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh013_2'].geometry}
          material={materials['DD9944.013']}
        />
      </group>
      <group
        name="palm_tree_01014"
        position={[21.38, -2.21, 43.98]}
        rotation={[-3.05, -1.28, -3]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh014"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh014'].geometry}
          material={materials['795548.014']}
        />
        <mesh
          name="palm_tree_01-Mesh014_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh014_1'].geometry}
          material={materials['8BC34A.014']}
        />
        <mesh
          name="palm_tree_01-Mesh014_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh014_2'].geometry}
          material={materials['DD9944.014']}
        />
      </group>
      <group
        name="palm_tree_01015"
        position={[33.94, -2.21, 45.39]}
        rotation={[-1.5, -1.37, -1.5]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh015"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh015'].geometry}
          material={materials['795548.015']}
        />
        <mesh
          name="palm_tree_01-Mesh015_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh015_1'].geometry}
          material={materials['8BC34A.015']}
        />
        <mesh
          name="palm_tree_01-Mesh015_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh015_2'].geometry}
          material={materials['DD9944.015']}
        />
      </group>
      <group name="SM_HutSM_Hut" position={[17.81, -1.39, 34.66]} scale={0.65}>
        <mesh
          name="SM_HutSM_Hut_1"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1.geometry}
          material={materials.lambert2SG}
        />
        <mesh
          name="SM_HutSM_Hut_1_1"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1_1.geometry}
          material={materials.lambert4SG}
        />
        <mesh
          name="SM_HutSM_Hut_1_2"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1_2.geometry}
          material={materials['lambert3SG.001']}
        />
      </group>
      <group
        name="SM_HutSM_Hut001"
        position={[-37.42, -1.06, -44.3]}
        rotation={[Math.PI, -1.38, Math.PI]}
        scale={0.65}
      >
        <mesh
          name="SM_HutSM_Hut_1001"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1001.geometry}
          material={materials['lambert2SG.001']}
        />
        <mesh
          name="SM_HutSM_Hut_1001_1"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1001_1.geometry}
          material={materials['lambert4SG.001']}
        />
        <mesh
          name="SM_HutSM_Hut_1001_2"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1001_2.geometry}
          material={materials['lambert3SG.002']}
        />
      </group>
      <group
        name="SM_HutSM_Hut002"
        position={[-49.58, -1.23, -14.28]}
        rotation={[0, -1.29, 0]}
        scale={0.65}
      >
        <mesh
          name="SM_HutSM_Hut_1002"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1002.geometry}
          material={materials['lambert2SG.002']}
        />
        <mesh
          name="SM_HutSM_Hut_1002_1"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1002_1.geometry}
          material={materials['lambert4SG.002']}
        />
        <mesh
          name="SM_HutSM_Hut_1002_2"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1002_2.geometry}
          material={materials['lambert3SG.003']}
        />
      </group>
      <group
        name="SM_HutSM_Hut003"
        position={[22.25, -1.14, -30.32]}
        rotation={[-Math.PI, 0.85, -Math.PI]}
        scale={0.65}
      >
        <mesh
          name="SM_HutSM_Hut_1003"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1003.geometry}
          material={materials['lambert2SG.003']}
        />
        <mesh
          name="SM_HutSM_Hut_1003_1"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1003_1.geometry}
          material={materials['lambert4SG.003']}
        />
        <mesh
          name="SM_HutSM_Hut_1003_2"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1003_2.geometry}
          material={materials['lambert3SG.004']}
        />
      </group>
      <group
        name="palm_tree_01016"
        position={[0.38, -2.62, -76.13]}
        rotation={[0, 1.43, 0]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh016"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh016'].geometry}
          material={materials['795548.016']}
        />
        <mesh
          name="palm_tree_01-Mesh016_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh016_1'].geometry}
          material={materials['8BC34A.016']}
        />
        <mesh
          name="palm_tree_01-Mesh016_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh016_2'].geometry}
          material={materials['DD9944.016']}
        />
      </group>
      <group
        name="palm_tree_01017"
        position={[-15.09, -3.92, -83.79]}
        rotation={[1.17, -1.27, 1.18]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh017"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh017'].geometry}
          material={materials['795548.017']}
        />
        <mesh
          name="palm_tree_01-Mesh017_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh017_1'].geometry}
          material={materials['8BC34A.017']}
        />
        <mesh
          name="palm_tree_01-Mesh017_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh017_2'].geometry}
          material={materials['DD9944.017']}
        />
      </group>
      <group
        name="palm_tree_01018"
        position={[-25.04, -2.85, -83.79]}
        rotation={[2.43, -1.14, 2.51]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh018"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh018'].geometry}
          material={materials['795548.018']}
        />
        <mesh
          name="palm_tree_01-Mesh018_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh018_1'].geometry}
          material={materials['8BC34A.018']}
        />
        <mesh
          name="palm_tree_01-Mesh018_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh018_2'].geometry}
          material={materials['DD9944.018']}
        />
      </group>
      <group
        name="palm_tree_01019"
        position={[5.06, -2.92, -66.76]}
        rotation={[2.75, 0.78, -2.83]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh019"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh019'].geometry}
          material={materials['795548.019']}
        />
        <mesh
          name="palm_tree_01-Mesh019_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh019_1'].geometry}
          material={materials['8BC34A.019']}
        />
        <mesh
          name="palm_tree_01-Mesh019_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh019_2'].geometry}
          material={materials['DD9944.019']}
        />
      </group>
      <group
        name="palm_tree_01020"
        position={[-50.64, -2.92, -64.08]}
        rotation={[2.75, 0.78, -2.83]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh020"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh020'].geometry}
          material={materials['795548.020']}
        />
        <mesh
          name="palm_tree_01-Mesh020_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh020_1'].geometry}
          material={materials['8BC34A.020']}
        />
        <mesh
          name="palm_tree_01-Mesh020_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh020_2'].geometry}
          material={materials['DD9944.020']}
        />
      </group>
      <group
        name="palm_tree_01021"
        position={[19.33, -2.37, -46.63]}
        rotation={[1.22, 1.28, -1.17]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh021"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh021'].geometry}
          material={materials['795548.021']}
        />
        <mesh
          name="palm_tree_01-Mesh021_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh021_1'].geometry}
          material={materials['8BC34A.021']}
        />
        <mesh
          name="palm_tree_01-Mesh021_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh021_2'].geometry}
          material={materials['DD9944.021']}
        />
      </group>
      <group
        name="palm_tree_01022"
        position={[28.44, -1.46, -24.28]}
        rotation={[1.22, 1.28, -1.17]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh022"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh022'].geometry}
          material={materials['795548.022']}
        />
        <mesh
          name="palm_tree_01-Mesh022_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh022_1'].geometry}
          material={materials['8BC34A.022']}
        />
        <mesh
          name="palm_tree_01-Mesh022_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh022_2'].geometry}
          material={materials['DD9944.022']}
        />
      </group>
      <group
        name="palm_tree_01023"
        position={[49.42, -1.92, -7.36]}
        rotation={[1.22, 1.28, -1.17]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh023"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh023'].geometry}
          material={materials['795548.023']}
        />
        <mesh
          name="palm_tree_01-Mesh023_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh023_1'].geometry}
          material={materials['8BC34A.023']}
        />
        <mesh
          name="palm_tree_01-Mesh023_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh023_2'].geometry}
          material={materials['DD9944.023']}
        />
      </group>
      <group
        name="palm_tree_01024"
        position={[44.43, -1.92, 4.22]}
        rotation={[1.87, 1.28, -1.85]}
        scale={0.05}
      >
        <mesh
          name="palm_tree_01-Mesh024"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh024'].geometry}
          material={materials['795548.024']}
        />
        <mesh
          name="palm_tree_01-Mesh024_1"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh024_1'].geometry}
          material={materials['8BC34A.024']}
        />
        <mesh
          name="palm_tree_01-Mesh024_2"
          castShadow
          receiveShadow
          geometry={nodes['palm_tree_01-Mesh024_2'].geometry}
          material={materials['DD9944.024']}
        />
      </group>
      <mesh
        name="Plant_Cube001"
        castShadow
        receiveShadow
        geometry={nodes.Plant_Cube001.geometry}
        material={materials['Plant.001']}
        position={[0, -0.65, -28.24]}
      />
      <mesh
        name="Plant_Cube002"
        castShadow
        receiveShadow
        geometry={nodes.Plant_Cube002.geometry}
        material={materials['Plant.002']}
        position={[-15.22, -0.65, -28.24]}
      />
      <mesh
        name="Plant_Cube003"
        castShadow
        receiveShadow
        geometry={nodes.Plant_Cube003.geometry}
        material={materials['Plant.003']}
        position={[-0.29, -1.65, -60.55]}
      />
      <mesh
        name="Plant_Cube004"
        castShadow
        receiveShadow
        geometry={nodes.Plant_Cube004.geometry}
        material={materials['Plant.004']}
        position={[-30.1, -1.65, -66.71]}
      />
      <mesh
        name="Plant_Cube005"
        castShadow
        receiveShadow
        geometry={nodes.Plant_Cube005.geometry}
        material={materials['Plant.005']}
        position={[-30.1, -1.68, -52.99]}
      />
      <mesh
        name="Plant_Cube006"
        castShadow
        receiveShadow
        geometry={nodes.Plant_Cube006.geometry}
        material={materials['Plant.006']}
        position={[-38.4, -1.41, 5.88]}
      />
      <mesh
        name="Plant_Cube007"
        castShadow
        receiveShadow
        geometry={nodes.Plant_Cube007.geometry}
        material={materials['Plant.007']}
        position={[-68.35, -1.41, -25.71]}
      />
      <mesh
        name="group1988159041"
        castShadow
        receiveShadow
        geometry={nodes.group1988159041.geometry}
        material={materials['mat22.013']}
        position={[10.7, -0.46, -13.22]}
        scale={4}
      />
      <mesh
        name="group337471551"
        castShadow
        receiveShadow
        geometry={nodes.group337471551.geometry}
        material={materials['mat22.013']}
        position={[66.66, -2.44, 6.74]}
        scale={15}
      />
      <mesh
        name="group1988159041001"
        castShadow
        receiveShadow
        geometry={nodes.group1988159041001.geometry}
        material={materials['mat22.014']}
        position={[-25.93, -0.5, 13.49]}
        scale={4}
      />
      <mesh
        name="group1988159041002"
        castShadow
        receiveShadow
        geometry={nodes.group1988159041002.geometry}
        material={materials['mat22.015']}
        position={[8.04, -1.32, 35.74]}
        scale={4}
      />
      <mesh
        name="group1988159041003"
        castShadow
        receiveShadow
        geometry={nodes.group1988159041003.geometry}
        material={materials['mat22.016']}
        position={[8.04, -2.06, -56.88]}
        scale={4}
      />
      <mesh
        name="group1988159041004"
        castShadow
        receiveShadow
        geometry={nodes.group1988159041004.geometry}
        material={materials['mat22.017']}
        position={[-24.05, -1.69, -56.88]}
        scale={4}
      />
      <mesh
        name="group1988159041005"
        castShadow
        receiveShadow
        geometry={nodes.group1988159041005.geometry}
        material={materials['mat22.018']}
        position={[-46.22, -1.13, -32.02]}
        scale={4}
      />
      <mesh
        name="group1988159041006"
        castShadow
        receiveShadow
        geometry={nodes.group1988159041006.geometry}
        material={materials['mat22.019']}
        position={[41.36, -1.69, -32.02]}
        scale={4}
      />
      <group
        name="SM_HutSM_Hut004"
        position={[22.25, -0.68, -6.04]}
        rotation={[-Math.PI, 1.01, -Math.PI]}
        scale={0.65}
      >
        <mesh
          name="SM_HutSM_Hut_1004"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1004.geometry}
          material={materials['lambert2SG.004']}
        />
        <mesh
          name="SM_HutSM_Hut_1004_1"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1004_1.geometry}
          material={materials['lambert4SG.004']}
        />
        <mesh
          name="SM_HutSM_Hut_1004_2"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1004_2.geometry}
          material={materials['lambert3SG.005']}
        />
      </group>
      <group
        name="SM_HutSM_Hut005"
        position={[28.02, -0.83, 10.51]}
        rotation={[-Math.PI, 1.01, -Math.PI]}
        scale={0.65}
      >
        <mesh
          name="SM_HutSM_Hut_1005"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1005.geometry}
          material={materials['lambert2SG.005']}
        />
        <mesh
          name="SM_HutSM_Hut_1005_1"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1005_1.geometry}
          material={materials['lambert4SG.005']}
        />
        <mesh
          name="SM_HutSM_Hut_1005_2"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1005_2.geometry}
          material={materials['lambert3SG.006']}
        />
      </group>
      <group
        name="SM_HutSM_Hut006"
        position={[-10.11, -1.39, 34.66]}
        scale={0.65}
      >
        <mesh
          name="SM_HutSM_Hut_1006"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1006.geometry}
          material={materials['lambert2SG.006']}
        />
        <mesh
          name="SM_HutSM_Hut_1006_1"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1006_1.geometry}
          material={materials['lambert4SG.006']}
        />
        <mesh
          name="SM_HutSM_Hut_1006_2"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1006_2.geometry}
          material={materials['lambert3SG.007']}
        />
      </group>
      <group
        name="SM_HutSM_Hut007"
        position={[-20.68, -0.72, 9.83]}
        rotation={[Math.PI, -1.54, Math.PI]}
        scale={0.65}
      >
        <mesh
          name="SM_HutSM_Hut_1007"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1007.geometry}
          material={materials['lambert2SG.007']}
        />
        <mesh
          name="SM_HutSM_Hut_1007_1"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1007_1.geometry}
          material={materials['lambert4SG.007']}
        />
        <mesh
          name="SM_HutSM_Hut_1007_2"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1007_2.geometry}
          material={materials['lambert3SG.008']}
        />
      </group>
      <group
        name="SM_HutSM_Hut008"
        position={[-29.1, -0.72, -10.22]}
        rotation={[Math.PI, -1.54, Math.PI]}
        scale={0.65}
      >
        <mesh
          name="SM_HutSM_Hut_1008"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1008.geometry}
          material={materials['lambert2SG.008']}
        />
        <mesh
          name="SM_HutSM_Hut_1008_1"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1008_1.geometry}
          material={materials['lambert4SG.008']}
        />
        <mesh
          name="SM_HutSM_Hut_1008_2"
          castShadow
          receiveShadow
          geometry={nodes.SM_HutSM_Hut_1008_2.geometry}
          material={materials['lambert3SG.009']}
        />
      </group>
      <mesh
        name="group1988159041007"
        castShadow
        receiveShadow
        geometry={nodes.group1988159041007.geometry}
        material={materials['mat22.020']}
        position={[0, -0.46, 13.49]}
        scale={4}
      />
      <mesh
        name="group1988159041008"
        castShadow
        receiveShadow
        geometry={nodes.group1988159041008.geometry}
        material={materials['mat22.021']}
        position={[12.81, -0.67, 13.49]}
        scale={4}
      />
      <mesh
        name="Plant_Cube008"
        castShadow
        receiveShadow
        geometry={nodes.Plant_Cube008.geometry}
        material={materials['Plant.008']}
        position={[43.41, -2.62, 51.46]}
      />
      <mesh
        name="Plant_Cube009"
        castShadow
        receiveShadow
        geometry={nodes.Plant_Cube009.geometry}
        material={materials['Plant.009']}
        position={[39.73, -1.64, -17.63]}
      />
      <mesh
        name="Cube003_Cube002"
        castShadow
        receiveShadow
        geometry={nodes.Cube003_Cube002.geometry}
        material={materials['Material.006']}
        scale={[3.5, 1, 3.5]}
      />
      <mesh
        name="Rowboat"
        castShadow
        receiveShadow
        geometry={nodes.Rowboat.geometry}
        material={materials.Mat}
        position={[57.36, 1.44, -63.87]}
        rotation={[-0.01, -0.13, -0.08]}
        scale={0.1}
      />
      <mesh
        name="gazebo"
        castShadow
        receiveShadow
        geometry={nodes.gazebo.geometry}
        material={materials.None}
        position={[-6.48, -0.8, -83.74]}
        rotation={[0, 1.03, 0]}
        scale={4}
      />
      <mesh
        name="Beach_Chair"
        castShadow
        receiveShadow
        geometry={nodes.Beach_Chair.geometry}
        material={materials['lambert3SG.010']}
        position={[54.86, 0.11, 18.5]}
        rotation={[0, 1.36, 0]}
        scale={0.01}
      />
      <mesh
        name="Beach_Chair001"
        castShadow
        receiveShadow
        geometry={nodes.Beach_Chair001.geometry}
        material={materials['lambert3SG.014']}
        position={[54.86, 0.01, 26.49]}
        rotation={[1.02, 1.41, -1.02]}
        scale={0.01}
      />
      <mesh
        name="Beach_Chair002"
        castShadow
        receiveShadow
        geometry={nodes.Beach_Chair002.geometry}
        material={materials['lambert3SG.017']}
        position={[-36.87, -0.61, -81.67]}
        rotation={[2.93, -0.83, 2.98]}
        scale={0.01}
      />
      <mesh
        name="Beach_Chair003"
        castShadow
        receiveShadow
        geometry={nodes.Beach_Chair003.geometry}
        material={materials['lambert3SG.018']}
        position={[-41.68, -0.5, -75.3]}
        rotation={[Math.PI, -0.72, Math.PI]}
        scale={0.01}
      />
      <group
        name="Beach_Umbrella"
        position={[-69.05, -0.94, -57.11]}
        rotation={[0, 0, -0.1]}
        scale={0.01}
      >
        <mesh
          name="Beach_Umbrella_1"
          castShadow
          receiveShadow
          geometry={nodes.Beach_Umbrella_1.geometry}
          material={materials['lambert3SG.010']}
        />
        <mesh
          name="Beach_Umbrella_1_1"
          castShadow
          receiveShadow
          geometry={nodes.Beach_Umbrella_1_1.geometry}
          material={materials.lambert5SG}
        />
      </group>
      <group
        name="Beach_Umbrella001"
        position={[-68.31, -0.94, -63.09]}
        rotation={[-Math.PI, 0.75, 3.13]}
        scale={0.01}
      >
        <mesh
          name="Beach_Umbrella_1001"
          castShadow
          receiveShadow
          geometry={nodes.Beach_Umbrella_1001.geometry}
          material={materials['lambert3SG.011']}
        />
        <mesh
          name="Beach_Umbrella_1001_1"
          castShadow
          receiveShadow
          geometry={nodes.Beach_Umbrella_1001_1.geometry}
          material={materials['lambert5SG.001']}
        />
      </group>
      <group
        name="Beach_Umbrella002"
        position={[52.97, -0.51, 18.9]}
        rotation={[-3.07, 0.74, 3.02]}
        scale={0.01}
      >
        <mesh
          name="Beach_Umbrella_1002"
          castShadow
          receiveShadow
          geometry={nodes.Beach_Umbrella_1002.geometry}
          material={materials['lambert3SG.012']}
        />
        <mesh
          name="Beach_Umbrella_1002_1"
          castShadow
          receiveShadow
          geometry={nodes.Beach_Umbrella_1002_1.geometry}
          material={materials['lambert5SG.002']}
        />
      </group>
      <group
        name="Beach_Umbrella003"
        position={[52.23, -0.51, 24.88]}
        rotation={[0, 0, -0.1]}
        scale={0.01}
      >
        <mesh
          name="Beach_Umbrella_1003"
          castShadow
          receiveShadow
          geometry={nodes.Beach_Umbrella_1003.geometry}
          material={materials['lambert3SG.013']}
        />
        <mesh
          name="Beach_Umbrella_1003_1"
          castShadow
          receiveShadow
          geometry={nodes.Beach_Umbrella_1003_1.geometry}
          material={materials['lambert5SG.003']}
        />
      </group>
      <group
        name="Beach_Umbrella004"
        position={[-35.74, -1.12, -78.8]}
        rotation={[-Math.PI, 0.65, 3.04]}
        scale={0.01}
      >
        <mesh
          name="Beach_Umbrella_1004"
          castShadow
          receiveShadow
          geometry={nodes.Beach_Umbrella_1004.geometry}
          material={materials['lambert3SG.015']}
        />
        <mesh
          name="Beach_Umbrella_1004_1"
          castShadow
          receiveShadow
          geometry={nodes.Beach_Umbrella_1004_1.geometry}
          material={materials['lambert5SG.004']}
        />
      </group>
      <group
        name="Beach_Umbrella005"
        position={[-39.93, -1.12, -74.48]}
        rotation={[-0.29, -1.38, -0.36]}
        scale={0.01}
      >
        <mesh
          name="Beach_Umbrella_1005"
          castShadow
          receiveShadow
          geometry={nodes.Beach_Umbrella_1005.geometry}
          material={materials['lambert3SG.016']}
        />
        <mesh
          name="Beach_Umbrella_1005_1"
          castShadow
          receiveShadow
          geometry={nodes.Beach_Umbrella_1005_1.geometry}
          material={materials['lambert5SG.005']}
        />
      </group>
    </group>
  );
}

useGLTF.preload('/world.glb');
